import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {ProductFeatureItem} from 'modules/product-card/components/ProductFeatureItem';
import {selectProductData} from 'modules/product-card/selectors';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {getProductFeatures} from 'modules/product-card/helpers/features';
import {Typography} from 'components/Typography';

export const ProductFeatureList: FC = () => {
    const productData = useAppSelector(selectProductData);

    const list = useMemo(() => {
        if (!productData) {
            return [];
        }

        return getProductFeatures(productData);
    }, [productData]);

    if (!list.length) {
        return null;
    }

    return (
        <>
            <Typography className={style.title}>Особенности</Typography>
            <div className={style.content}>
                {list.map(({icon, title}) => {
                    return <ProductFeatureItem icon={icon} key={icon} title={title} />;
                })}
            </div>
        </>
    );
};
